<template>
  <button
      class="copy-button"
      @click="copyText"
      :title="copied ? '已复制!' : '复制'"
  >
    {{ copied ? '已复制!' : '复制' }}
  </button>
</template>

<script>
import { copyToClipboard } from '@/utils/clipboard'

export default {
  props: {
    text: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      copied: false
    }
  },
  methods: {
    async copyText() {
      const success = await copyToClipboard(this.text)
      if (success) {
        this.copied = true
        setTimeout(() => {
          this.copied = false
        }, 2000)
      }
    }
  }
}
</script>

<style scoped>
.copy-button {
  background-color: #4CAF50;
  min-width: 60px;
}
.copy-button:hover {
  background-color: #45a049;
}
</style>
